export default __webpack_public_path__ + "app/components/notifications/unkwownCurrencies.html";